import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-small-heading"]
const _hoisted_2 = {
  class: "icon-text__icon",
  "aria-hidden": "true"
}

interface Props {
	isSmallHeading?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'IconText',
  props: {
    isSmallHeading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "icon-text",
    "data-small-heading": __props.isSmallHeading ? true : null
  }, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    _renderSlot(_ctx.$slots, "content")
  ], 8, _hoisted_1))
}
}

})